import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import iqd_rounding from "../../utils/iqd_rounding";
import money_rounding from "../../utils/money_rounding";

const Expireitem = () => {
    const { initState, recaller, setrecaller, initDispatch, clear } =
        useContext(GlobalContext);
    return (
        <div className="min-h-screen bg-slate-50 p-6 md:p-8">
            {/* Page Header */}
            <div className="flex items-center justify-between mb-8">
                <div>
                <h1 className="text-2xl font-bold text-slate-800">ئاگادارکردنەوە</h1>
                <p className="text-sm text-slate-400 mt-0.5">کاڵای نزیک لە بەسەرچوون</p>
                </div>
            </div>
            
            {/* Expense List Card */}
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
                
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                <h2 className="text-base font-semibold text-slate-800">لیستی کاڵای نزیک لە بەسەرچوون</h2>
                </div>

                {/* Table */}
                <table className="w-full">
                    <thead>
                        <tr className="bg-slate-50 border-b border-slate-100">
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                ناوی کاڵا
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                باڕکۆد
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                نرخ
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                بڕی ماوە
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                بەرواری بەسەرچون
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                        {initState.expire_item.map((lis) => {
                            const today = new Date();
                            const expDate = new Date(lis.item_exp_date);
                            const diffTime = expDate - today;
                            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                        
                            let bgColor = "bg-white";
                            if (diffDays <= 30) {
                                bgColor = "bg-red-400";
                            } else if (diffDays <= 60) {
                                bgColor = "bg-yellow-400";
                            } else {
                                bgColor = "bg-green-400";
                            }
                        
                            return (
                                <tr
                                    key={lis.item_id}
                                    className={`${bgColor} transition-colors duration-200`}
                                >
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {lis.item_name}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {lis.item_barcode}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                            {numberbeautify(iqd_rounding(money_rounding(lis.item_price)))}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {lis.item_qty}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {lis.item_exp_date}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Expireitem;